import { Map as ImmutableMap, Record } from 'immutable';

export const mkFieldEncryption = Record({
  id: undefined,
  expiresAt: undefined,
  algorithm: undefined,
  publicKey: undefined,
  signatureAlgorithm: undefined,
  signature: undefined,
});

export const mkBiller = Record({
  id: undefined,
  name: undefined,

  websiteURL: undefined,
  loginURL: undefined,

  resetPasswordURL: undefined,
  createAccountURL: undefined,

  accountType: undefined,
  credentials: undefined,

  refreshingEnabled: false,
  fieldEncryption: mkFieldEncryption(),

  logo: undefined,
});

export const mkBillerStore = Record({
  resourcesById: ImmutableMap(),
  lastSyncDate: null,

  loadPending: true,
  isLoading: false,

  error: null,

  popularIds: null,
});
